//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';
import 'jquery-typeahead';

export default {
  name: "InputTypehead",
  props: [ 
      'airportData', 
      'inputValue', 
      'inputClass', 
      'inputDataWowAttr', 
      'inputName', 
      'inputType', 
      'inputAutocomplete', 
      'inputPlaceholder', 
      'multiTripIndex' 
  ],
  data() {
    return {
      formData: this.value || {}
    };
  },
  mounted() {
      this.airportData
      .then( _airportData => {
        $(this.$refs.input).typeahead({
          display: 'airportname',
          minLength: 1,
          hint : true,
          highlight : false,
          debug: false,
          maxItem: 100,
          offset: false,
          cache : false,
          cancelButton: false,
          source: {
            data: _airportData,
          },
          callback: {
            onLeave: () => {
              const val = this.$refs.input.value || null;
              this.$emit('on-update', this.inputName, val, this.multiTripIndex);
            },
          },
        });
      });

      $(this.$refs.input).on('change', (e) => {
        const val = this.$refs.input.value || null;
        this.$emit('on-update', this.inputName, val, this.multiTripIndex);
      });
  },
  beforeDestroy() {
    
  },
  methods: {
  }
};
